var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.prePicture && _vm.prePicture.length
        ? _c("timeline-task-list", {
            attrs: {
              id: "prePictureDay",
              name: "prePictureDay",
              color: "sgp-info",
              title: "Pre Picture Day",
              tasks: _vm.prePicture,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.postPicture && _vm.postPicture.length
        ? _c("timeline-task-list", {
            attrs: {
              id: "postPictureDay",
              name: "postPictureDay",
              color: "sgp-primary",
              title: "Post Picture Day",
              tasks: _vm.postPicture,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.preRetake && _vm.preRetake.length
        ? _c("timeline-task-list", {
            attrs: {
              id: "preRetakeDay",
              name: "preRetakeDay",
              color: "sgp-default",
              title: "Pre Make Up Day",
              tasks: _vm.preRetake,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.postRetake && _vm.postRetake.length
        ? _c("timeline-task-list", {
            attrs: {
              id: "postRetakeDay",
              name: "postRetakeDay",
              color: "sgp-secondary",
              title: "Post Make Up Day",
              tasks: _vm.postRetake,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }